import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddBrandPartyDiscount = () => {
    const [formData, setFormData] = useState({
        description: '',
        date: '',
        sno: '',
        party_code: '',
        party_name: '',
        brand_code: '',
        brand_name: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submit
   // Handle form submit
const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validate required fields
    if (!formData.description || !formData.date || !formData.sno || !formData.party_code || !formData.party_name || !formData.brand_code || !formData.brand_name) {
        setError("All fields are required.");
        setLoading(false);
        return;
    }

    // Post the form data to the API
    fetch('http://localhost:8000/api/brandpartydiscount', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    })
        .then((response) => response.json())
        .then((data) => {
            console.log("API Response:", data); // Log the API response
            if (data.status === 'success') {
                // On success, navigate to the discount list page
                navigate('/BrandPartyDiscountList');
            } else {
                // Handle error response from the API
                setError(data.message || 'Failed to add discount. Please try again.');
            }
        })
        .catch((error) => {
            console.error("API Error:", error); // Log any errors
            setError('Something went wrong! Please try again.');
        })
        .finally(() => {
            setLoading(false);
        });
};


    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Brand Party Discount</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Brand Party Discount Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    )}

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="sno" className="form-label">SNO</label>
                                        <input
                                            type="number"
                                            id="sno"
                                            className="form-control"
                                            name="sno"
                                            value={formData.sno}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="party_code" className="form-label">Party Code</label>
                                        <input
                                            type="text"
                                            id="party_code"
                                            className="form-control"
                                            name="party_code"
                                            value={formData.party_code}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="party_name" className="form-label">Party Name</label>
                                        <input
                                            type="text"
                                            id="party_name"
                                            className="form-control"
                                            name="party_name"
                                            value={formData.party_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="brand_code" className="form-label">Brand Code</label>
                                        <input
                                            type="text"
                                            id="brand_code"
                                            className="form-control"
                                            name="brand_code"
                                            value={formData.brand_code}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="brand_name" className="form-label">Brand Name</label>
                                        <input
                                            type="text"
                                            id="brand_name"
                                            className="form-control"
                                            name="brand_name"
                                            value={formData.brand_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Submitting...' : 'Add Discount'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddBrandPartyDiscount;
